import { pdf } from "@react-pdf/renderer";
import { API } from "../config";
import CONSTANTS from "../constants/constants";
import UnderMaintenanceService from "../components/UnderMaintenance/services/UnderMaintenanceService";
import { ROUTES } from "../constants/routes";

class Utility {

    constructor() {
        //
    }

    // add commas between numbers
    numberWithCommas(num: string) {
        num = num?.toString();
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern?.test(num))
            num = num?.replace(pattern, "$1,$2");
        return num;
    }

    //  get current Date and Time stamp
    getCurrentTimestamp = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };


    getFormattedDateTime = (requiredDate: Date, configDate?: number) => {
        const year = requiredDate.getFullYear();
        const month = String(requiredDate.getMonth() + 1).padStart(2, "0");
        const date = configDate ? configDate : String(requiredDate.getDate()).padStart(2, "0");
        return `${year}/${month}/${date}`;
    };

    toSeconds = (hrs: number, min: number, sec: number) => (hrs * 60 * 60 + min * 60 + sec);

    // give sum of quantities
    getQuantitySum = (quantity: string) => {
        const addQuantity = quantity;
        const plusQuantity = addQuantity.split("|");
        let sum = 0;
        for (let i = 0; i < plusQuantity.length; i++) {
            sum += parseInt(plusQuantity[i]);
        }
        return sum;
    };

    // convert the value into YYYY MM with JP Format
    getCustomDateYMDJP = (date: string) => {
        const year = date.slice(0, 4);
        const month = date.slice(4, 6);
        const JPDate = year + " 年 " + month + " 月分 ";

        return JPDate;
    };

    // convert the value into YYYY MM with JP Format
    customDateJPYYMMDD(date: any) {
        const newDate = date.split(" ");
        const updatedDate = newDate[0];
        const year = updatedDate.slice(0, 4);
        const month = updatedDate.slice(5, 7);
        const day = updatedDate.slice(8, 10);
        return year + "年" + month + "月" + day + "日";
    }

    // convert the value into YYYY MM with JP Format current date and time
    customPublicationDateJPYYMMDD() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return year + "年" + month + "月" + day + "日";
    }
    // download PDF with view on new Tab on a click
    downloadPdfWithView = async (html: any, fileName: string) => {
        const pdfBlob = await pdf(html).toBlob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        const newTab = document.createElement("a");
        link.href = pdfUrl;
        newTab.href = pdfUrl;
        link.setAttribute("download", fileName);
        newTab.setAttribute("target", "_blank");
        document.body.appendChild(link);
        document.body.appendChild(newTab);
        link.click();
        newTab.click();
    };

    // download PDF with a click
    downloadPdfWithoutView = async (html: any, fileName: string) => {
        const pdfBlob = await pdf(html).toBlob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
    };

    // print PDF
    printPdf = async (html: any, filename: string, print: boolean) => {
        const pdfBlob = await pdf(html).toBlob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = pdfUrl;
        const pdfWindow = window.open(pdfUrl, filename, "popup");
        pdfWindow?.document.close();
        pdfWindow?.focus();
        if (print) {
            setTimeout(() => {
                pdfWindow?.print();
            }, 2000);
        }
        return false;
    };

    // katakana full width character
    getKatakanaFullWidth = () => {
        const KatakanaFullWidthArray = CONSTANTS.KATAKANA_FULL_WIDTH_ARRAY;
        return KatakanaFullWidthArray;
    };
    // katakana half width character
    getKatakanaHalfWidth = () => {
        const KatakanaHalfWidthArray = CONSTANTS.KATAKANA_HALL_WIDTH_ARRAY;
        return KatakanaHalfWidthArray;
    };
    // katakana full width character for payee info 
    getKatakanaFullWidthForPayeeInfo = () => {
        const KatakanaFullWidthArray = CONSTANTS.KATAKANA_FULL_WIDTH_ARRAY_FOR_PAYEE_INFO;
        return KatakanaFullWidthArray;
    };
    // katakana half width character for payee info
    getKatakanaHalfWidthForPayeeInfo = () => {
        const KatakanaHalfWidthArray = CONSTANTS.KATAKANA_HALL_WIDTH_ARRAY_FOR_PAYEE_INFO;
        return KatakanaHalfWidthArray;
    };
    // server sent event 
    connectionToSSE = async (setIsMsgRequired:any,setMsgVisibility:any,setVersion:any,setIsUnderMaintenance:any) => {
        let eventSource: EventSource | null  = null;
 
        function connectToSSE() {
            eventSource = new EventSource(API.SSE_API_PATH);
            eventSource.addEventListener("notification", (e) => {
                const systemUpdateData = JSON.parse(e.data);
                setIsMsgRequired(systemUpdateData?.message);
                localStorage.setItem("systemUpdateNotification", systemUpdateData?.message);
                setMsgVisibility(systemUpdateData?.orientation);
                localStorage.setItem("systemUpdateNotificationVisibility", systemUpdateData?.orientation);
            });
            eventSource.addEventListener("version", (e) => {
                setVersion(e.data);
            });
            eventSource.addEventListener("maintenance", (e) => {
                setIsUnderMaintenance(e.data);
            });
            eventSource.addEventListener("error", () => {
                if (eventSource?.readyState === EventSource.CLOSED) {
                    reconnectToSSE();
                }
            });
        }
 
        function reconnectToSSE() {
            if (eventSource) {
                eventSource.close(); 
            }
            setTimeout(() => {
                connectToSSE();
            }, 3000);
        }
        connectToSSE();
 
        return () => {
            if(eventSource != null) {            
                eventSource.close();
            }
        };
 
    };
    // Convert File name extension to small letter
    convertExtensionToLowerCase(filename:any) {
        const parts = filename.name.split(".");
        if (parts.length < 2) return filename; 
        parts[parts.length - 1] = parts[parts.length - 1].toLowerCase();
        return parts.join(".");
    }

    // Common function for check If the system is in maintenance mode and the user is not a Super Admin then user is redirected to the "Under Maintenance" page.
    getMaintenancePage = ( showSnackbar:any , loggedInUserType :any) => {
        if( loggedInUserType != CONSTANTS.USER_TYPE_SUPER_ADMIN ){
            const isHitDummyURL = false;
            new UnderMaintenanceService({}, isHitDummyURL)
                .UnderMaintenanceGetService()
                .then((res: any)=>{
                    if(res?.maintenanceMode == "true"){
                        window.location.href = ROUTES.UNDER_MAINTENANCE;
                    }
                })
                .catch((err)=>{
                    showSnackbar(err?.message, false);
                });
        }
    };

    // get the current date and time in YYYY/MM/DD format for the imgix URL
    dateTimeCache  = () => {
        const now = new Date();
        const formatType:any = "Hours"; 
        let formattedDate;
        switch (formatType) {
        case "Hours": 
            formattedDate = now.toISOString().split("T")[0] + "T" + now.getHours();
            break;
        case "Minute": 
            formattedDate = now.toISOString().split("T")[0] + "T" + now.getHours() + ":" + String(now.getMinutes()).padStart(2, "0");
            break;
        case "Second": 
            formattedDate = now.toISOString().split("T")[0] + "T" + now.getHours() + ":" + String(now.getMinutes()).padStart(2, "0") + ":" + String(now.getSeconds()).padStart(2, "0");
            break;
        default:
            formattedDate = now;
        }
        return formattedDate;
    };

    // reset the time to 00:00:00 for the given date 
    getDateOnly = (date: Date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    };

    // get the time in seconds for the given date
    currentTimeSecond () {
        return Math.floor(new Date().getTime() / 1000);
    }
}
export default Utility;